import React from 'react';

import Click2PayLinkCard from '@/widgets/Click2Pay/Click2PayLinkCard';

import VisaCalculatorRedirectButton from '@components/visa-calculator-redirect-button/VisaCalculatorRedirectButton';

const OverviewNavigationPanel = () => (
    <div className="overview-navigation-panel">
        <VisaCalculatorRedirectButton />
        <Click2PayLinkCard />
    </div>
);

export default OverviewNavigationPanel;
